import { WithStyles, withStyles } from '@mui/styles';

import ClientUserSearch from './ClientUserSearch';
import { muiStyles } from './styles';

export type ClientUserSearchProps = WithStyles<typeof muiStyles>;

export default withStyles(muiStyles)(ClientUserSearch);